import React, {
  createElement,
  PropsWithChildren,
  ReactNode,
  forwardRef,
  useImperativeHandle,
  Ref,
} from "react";
import { isFunction, type ValidationSchema } from "./utils";
import { useForm, useField } from "./hooks";
import { FormProvider } from "./provider";
import { ScrollOnError } from "./ScrollToError";
import { FormProps, FormApi } from "./types";

type RenderFunction = (props: PropsWithChildren<any>) => JSX.Element;

interface FormyProps extends FormProps<any> {
  children: ReactNode | RenderFunction;
}

export const Formy = forwardRef(
  ({ children, ...props }: FormyProps, ref: Ref<FormApi<any>>) => {
    const api = useForm<typeof props.initialValues>(props);
    useImperativeHandle(ref, () => api, [api]);

    return (
      <FormProvider value={api}>
        <ScrollOnError />
        {isFunction(children) ? createElement(children, api) : children}
      </FormProvider>
    );
  }
);

Formy.displayName = "Formy";

export { useField, ValidationSchema, FormApi };
